import Big from 'big.js';

// Global big.js settings the whole app relies on. Import this module before
// anything else (src/index.tsx does) so they never depend on import order.
// The smart-route Web Worker has its own big.js and imports it too.
//
// Round down, keep 40 decimal places in division, and never switch to
// exponential notation for yocto-scale amounts (10^24 must stringify as
// digits, not "1e+24", before it goes into a contract call).
Big.RM = 0;
Big.DP = 40;
Big.NE = -40;
Big.PE = 40;
